import { Vector2 } from "../../../common/vector2.js";
import { StatisticsStorage } from "../../../storage/statistics_storage.js";
import type { GameStatistics } from "../../../storage/statistics_storage.js";
import { CurrencyBar } from "../../common_ui_elements/currency_bar.js";
import { PlayerAvatar } from "../../common_ui_elements/player_avatar.js";
import { UIElement } from "../../common_ui_elements/ui_element.js";
import { UIElementHolder } from "../../common_ui_elements/ui_element_holder.js";
import { UIImage } from "../../common_ui_elements/ui_image.js";

export interface AdventureRewardHudBadge
{
  icon: UIImage;
  target: Vector2;
}

export interface AdventureRewardHudRefs
{
  row: UIElementHolder;
  avatar_holder: UIElement;
  avatar_target: Vector2;
  heart: AdventureRewardHudBadge;
  coin: AdventureRewardHudBadge;
  bar: CurrencyBar;
}

export class AdventureRewardHud
{
  static build( ctx: CanvasRenderingContext2D, parent: UIElement, screen_w: number, stats: GameStatistics = StatisticsStorage.load() ): AdventureRewardHudRefs
  {
    const row = new UIElementHolder( ctx, 0, 0, screen_w, LayoutScaler.heightFromDesign( 222 ), false );
    parent.addChild( row );

    const avatar_holder = this.buildAvatar( ctx, row );
    const bar_position = CurrencyBar.defaultPosition();
    const bar = new CurrencyBar( ctx, bar_position.x, bar_position.y, { stats } );
    row.addChild( bar );

    return {
      row,
      avatar_holder,
      avatar_target: avatar_holder.center(),
      heart: { icon: bar.heartIcon(), target: bar.heartTarget() },
      coin: { icon: bar.coinIcon(), target: bar.coinTarget() },
      bar,
    };
  }

  static animateCoins( hud: AdventureRewardHudRefs, to: number, start_time: number, duration_ms: number ): void
  {
    hud.bar.animateCoinsTo( to, start_time, duration_ms );
  }

  static refreshHearts( hud: AdventureRewardHudRefs, stats: GameStatistics, now_ms: number ): void
  {
    hud.bar.refreshHearts( stats, now_ms );
  }

  private static buildAvatar( ctx: CanvasRenderingContext2D, row: UIElement ): PlayerAvatar
  {
    const position = PlayerAvatar.defaultPosition();
    const size = PlayerAvatar.defaultSize();

    const avatar = new PlayerAvatar( ctx, position.x, position.y, size );
    row.addChild( avatar );

    return avatar;
  }
}
